// extracted by mini-css-extract-plugin
export default {"container":"Section_container__vEvWA","section":"Section_section__Z2PLw","title":"Section_title__SLHvV"};